module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Cooking/Sieve-15cedae9a417b17685f3d396a8546d2c.svg";